export default "/images/a57840a2d5f02347af1b2004b50f9324.avif";